var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationProvider',{attrs:{"name":_vm.name,"rules":_vm.rules,"vid":_vm.vid},scopedSlots:_vm._u([{key:"default",fn:function({ errors }){return [_c('BaseCheckboxGroup',_vm._g({attrs:{"label":_vm.label,"name":_vm.name,"value":_vm.value,"options":_vm.options,"errors":errors}},_vm.$listeners))]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }